var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 44C31 44.5523 31.4477 45 32 45C32.5523 45 33 44.5523 33 44H31ZM32.7071 19.2929C32.3166 18.9024 31.6834 18.9024 31.2929 19.2929L24.9289 25.6569C24.5384 26.0474 24.5384 26.6805 24.9289 27.0711C25.3195 27.4616 25.9526 27.4616 26.3431 27.0711L32 21.4142L37.6569 27.0711C38.0474 27.4616 38.6805 27.4616 39.0711 27.0711C39.4616 26.6805 39.4616 26.0474 39.0711 25.6569L32.7071 19.2929ZM33 44V20H31V44H33Z",
    fill: "#f6e7ca"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavArrowUp);
export default __webpack_public_path__ + "static/media/NavArrowUp.8f7d00995f767c3332245eb8d7758fcd.svg";
export { ForwardRef as ReactComponent };